import { InterestRepository } from "../repository";
import { Course, Interest } from "../../../domain/entities/entities";
import http from "../http";
import { wrapErrorHandler } from "../utils/wrap_error_handler";
import { Order } from "../../../domain/entities/order";
import { ListResponse } from "../../../domain/entities/shop/product/listResponse";

class _Interest_repository implements InterestRepository {
  list(): Promise<Interest[]> {
    return wrapErrorHandler<Interest[]>(async () => {
      const response = await http.get("/api/decola/interest/list");
      return response.data.interests;
    });
  }

  relateInterestToUser(interests: Array<Interest>): Promise<void> {
    return wrapErrorHandler<void>(async () => {
      await http.post("/api/decola/interest/link", { interests: interests });
    });
  }

  listUserInterest(): Promise<Interest[]> {
    return wrapErrorHandler<Interest[]>(async () => {
      const response = await http.get("/api/decola/list/interests/user");
      return response.data.interests;
    });
  }

  getUserInterests(): Promise<Interest[]> {
    return wrapErrorHandler<Interest[]>(async () => {
      const response = await http.get("/api/decola/list/interests/user/course");
      return response.data.interests;
    });
  }

  listTrainingsByInterest(
    order: Order,
    interestID: number
  ): Promise<ListResponse<Course>> {
    return wrapErrorHandler<ListResponse<Course>>(async () => {
      const response = await http.get(
        `/api/decola/interest/${interestID}/courses`,
        {
          params: {
            page: order.page,
            search: order.search,
            status: order.status,
            limit: 20
          }
        }
      );

      return response.data;
    });
  }
}

export const interfaceInterestRepository: InterestRepository = new _Interest_repository();
